// Carousel.jsx
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import bali from "../Assets/PopularDestination/bali.jpg";
import abudhabi from "../Assets/PopularDestination/abudhabi.jpg";
import gulmarg from "../Assets/PopularDestination/gulmarg.jpg";
import allepey from "../Assets/PopularDestination/allepey.jpg";
import istanbul from "../Assets/PopularDestination/istanbul.jpg";
import lakshwadeep from "../Assets/PopularDestination/lakshwadeep.jpg";

const Carousel = () => {
  const destinations = [
    { img: bali, name: "Bali", country: "Indonesia", tags: ["Beaches", "Temples"], bgColor: "red" },
    { img: abudhabi, name: "Abu Dhabi", country: "UAE", tags: ["Adventure ", "Skyscrapers"], bgColor: "yellow" },
    { img: gulmarg, name: "Gulmarg", country: "India", tags: ["Snow Sports", "Scenic Beauty"], bgColor: "gray" },
    { img: allepey, name: "Alleppey", country: "India", tags: ["Backwaters", "Houseboats"], bgColor: "green" },
    { img: istanbul, name: "Istanbul", country: "Turkey", tags: ["Historic Sites", "Bazaars"], bgColor: "purple" },
    { img: lakshwadeep, name: "Lakshwadeep", country: "India", tags: ["Island Beaches", "Coral Reefs"], bgColor: "blue" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="carousel-container mx-auto p-4">
      <Slider {...settings}>
        {destinations.map((destination, index) => (
          <div key={index} className="p-2">
            <a href="/form" className="block relative overflow-hidden rounded-lg">
              <img
                alt={destination.name}
                className="block h-full w-full rounded-lg object-cover object-center"
                src={destination.img}
              />
            </a>
            <div className='ml-2 mt-2'>
              <p className="text-lg font-semibold text-gray-800">{destination.name}, <span className="text-sm text-gray-600 font-normal">{destination.country}</span></p>
              <div className="flex mt-1 space-x-2">
                {destination.tags.map((tag, i) => (
                  <span
                    key={i}
                    className={`bg-${destination.bgColor}-100 text-${destination.bgColor}-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-${destination.bgColor}-400 border border-${destination.bgColor}-400 rounded-xl`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
